<template>
  <div>
    <BreadCrumb :data="breadCrumb" />

    <Table
      :fields="fields"
      :items="list"
      type="List"
      :loading="loading"
      :limit="limit"
      :setLimit="setLimit"
      :page="page"
      :setPage="setPage"
      :search="search"
      :gSearch="gSearch"
      :filtered="filtered"
      :actions="actions"
      :actionEvent="actionEvent"
      :eventBtn="eventBtn"
      :popover="popover"
    />
    <Modals
      :open="modalOpen"
      :modalEvent="openModal"
      :modalProps="modalProps"
      :form="currentForm"
      :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import i18n from "@/plugins/i18n";
import Modals from "./modals/";
import Table from "@/components/Table";
let breadCrumb = [
  { label: i18n.t("pages.defination.name"), url: "/Defination" },
  {
    label: i18n.t("pages.defination.signalGroup"),
    url: "/Defination/SignalGroups"
  }
];

let popover = [
  {
    key: "notify_detail",
    label: i18n.t('defination.signalGroups.list.notify_detail'),
    keys: ["notify_detail"]
  },
  {
    key: "audio_url",
    label: i18n.t('defination.signalGroups.list.audio_url'),
    keys: ["audio_url"]
  },
  {
    key: "auto_postpone_time",
    label: i18n.t('defination.signalGroups.list.auto_postpone_time'),
    keys: ["auto_postpone_time"]
  },
]

let fields = [
  { key: "code", label: i18n.t('defination.signalGroups.list.code'), keys: ["code"] },
  { key: "name", label: i18n.t('defination.signalGroups.list.name'), keys: ["name"] },
    {
    key: "restore_id",
    label: i18n.t('defination.signalGroups.list.restore_id'),
    keys: ["restore_group_name"]
  },
  {
    key: "status_icon",
    label: i18n.t('defination.signalGroups.list.is_bulk_process'),
    keys: ["is_bulk_process"]
  },
  {
    key: "status_icon",
    label: i18n.t('defination.signalGroups.list.is_auto_postpone'),
    keys: ["is_auto_postpone"]
  },
    {
    key: "status_icon",
    label: i18n.t('defination.signalGroups.list.is_bulk_postpone'),
    keys: ["is_bulk_postpone"]
  },
  {
    key: "status_icon",
    label: i18n.t('defination.signalGroups.list.is_free_sms'),
    keys: ["is_free_sms"]
  },
  {
    key: "status_icon",
    label: i18n.t('defination.signalGroups.list.is_auto_process'),
    keys: ["is_auto_process"]
  },
  
  { key: "actions", label: i18n.t('defination.signalGroups.list.actions'), keys: ["actions"] }
];

export default {
  name: "SignalGroups",
  async created() {
    await this.$store.dispatch("signal_group_list");
  },
  data: function() {
    return {
      breadCrumb,
      modalOpen: false,
      modalProps: {},
      currentForm: "Groups",
      modalName: "",
      fields,
      limit: 10,
      page: 1,
      offset: 0,
      dismissCountDown: 0,
      params: {
        limit: 10,
        offset: 0
      },
      filtered: [
        "code",
        "name",
        "status_icon",
        "restore_id",
        "auto_postpone_time",
        "actions"
      ],
      actions: [
        { key: "edit", text: i18n.t('general.edit'), state: 1 },
        { key: "delete", text: i18n.t('general.delete') }
      ],
      popover
    };
  },

  components: {
    BreadCrumb,
    Modals,
    Table
  },
  methods: {
    search(){
      
    },
    gSearch(data){
      
    },
    setLimit: function(limit) {
      this.limit = limit;
      this.$store.dispatch("signal_group_list", this.params);
    },
    setPage: function(page) {
      if (page > 0) {
        this.page = page;
        this.offset = (page - 1) * this.limit;
        this.$store.dispatch("signal_group_list", this.params);
      }
    },
    openModal: function(state, modal, props) {
      this.modalOpen = state;
      this.modalProps = props;
      this.modalName = modal;
    },
    actionEvent: async function(key, data) {
      switch (key) {
        case "edit":
          this.openModal(true, "edit", data);
          break;
        case "delete":
          this.openModal(true, "delete", data);
          break;
        case "add":
          this.openModal(true, "add");
          break;
      }
    },

  },
  computed: {
    loading() {
      return this.$store.getters.getDefinationLoading;
    },
    list() {
      return this.$store.getters.getSignalGroups;
    },
      eventBtn(){
      return {
        text:i18n.t('general.add'),
        clicked:()=>{
         this.actionEvent("add");
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>
@import "./styles/signalGroups.min.css";
</style>



// WEBPACK FOOTER //
// src/pages/General/Defination/SignalGroups.vue